var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Update PODQueueFlags")]), _vm._v(" "), _c('b-card', [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("SR Id")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.srId),
      expression: "srId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('srId')
    },
    attrs: {
      "id": "srId",
      "type": "text",
      "name": "srId",
      "placeholder": "Enter SR Id"
    },
    domProps: {
      "value": (_vm.srId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.srId = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('srId')),
      expression: "errors.has('srId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Enter SR Id"))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.shipmenttype,
      "selected-option": _vm.shipmentObj,
      "name": "shipment",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "select": _vm.SelectShipmentType
    },
    model: {
      value: (_vm.shipment),
      callback: function($$v) {
        _vm.shipment = $$v
      },
      expression: "shipment"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipment')),
      expression: "errors.has('shipment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Select Shipment Type"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getpod()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Get")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-success mr-4 ml-4",
    attrs: {
      "type": "button",
      "disabled": _vm.isUpdateDisabled == true
    },
    on: {
      "click": function($event) {
        return _vm.updatepod()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Update")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PODUpdateQueueFlag")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.poddata), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.IsPODQueueShipment))])])
  }), _vm._v(" "), (_vm.poddata.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No Record Found")])]) : _vm._e()], 2)])])])], 1)])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1045cca4","hasScoped":true}!./src/views/components/UpdatePODQueueFlags/UpdatePODQueueFlags.component.html
// module id = 1413
// module chunks = 1